import rotatePolygon from '%paysera_seat_selection/js/seatSelection/redux/component/orm/services/rotatePolygon';
import { round } from 'mathjs';

function compileRowPolygon(row) {
    if (row.seats.count() === 0) {
        return row;
    }

    const firstSeat = row.seats.first();

    let firstSeatCenter = { ...firstSeat.compiled.polygon.center };
    if (row.transformation.rotation !== 0) {
        [firstSeatCenter] = rotatePolygon(
            [firstSeatCenter],
            row.compiled.polygon.center,
            -row.transformation.rotation,
        );
    }
    if (row.sector.transformation.rotation !== 0) {
        [firstSeatCenter] = rotatePolygon(
            [firstSeatCenter],
            row.sector.compiled.polygon.center,
            -row.sector.transformation.rotation,
        );
    }

    let westPoint = firstSeatCenter.x;
    let eastPoint = firstSeatCenter.x;
    let northPoint = firstSeatCenter.y;
    let southPoint = firstSeatCenter.y;

    row.seats.toModelArray().forEach((seat) => {
        let seatPoints = seat.compiled.polygon.points;
        if (row.transformation.rotation !== 0) {
            seatPoints = rotatePolygon(
                seatPoints,
                row.compiled.polygon.center,
                -row.transformation.rotation,
            );
        }
        if (row.sector.transformation.rotation !== 0) {
            seatPoints = rotatePolygon(
                seatPoints,
                row.sector.compiled.polygon.center,
                -row.sector.transformation.rotation,
            );
        }

        seatPoints.forEach((point) => {
            if (point.x < westPoint) {
                westPoint = point.x;
            }
            if (point.x > eastPoint) {
                eastPoint = point.x;
            }
            if (point.y < northPoint) {
                northPoint = point.y;
            }
            if (point.y > southPoint) {
                southPoint = point.y;
            }
        });
    });

    const width = eastPoint - westPoint;
    const height = southPoint - northPoint;
    let center = {
        x: round(westPoint + width / 2, 2),
        y: round(northPoint + height / 2, 2),
    };

    let points = [
        { x: westPoint, y: northPoint },
        { x: eastPoint, y: northPoint },
        { x: eastPoint, y: southPoint },
        { x: westPoint, y: southPoint },
    ];

    if (row.transformation.rotation !== 0) {
        points = rotatePolygon(points, center, row.transformation.rotation);
    }
    if (row.sector.transformation.rotation !== 0) {
        points = rotatePolygon(points, row.sector.compiled.polygon.center, row.sector.transformation.rotation);
        [center] = rotatePolygon([center], row.sector.compiled.polygon.center, row.sector.transformation.rotation);
    }

    row.compiled = {
        ...row.compiled,
        polygon: {
            center,
            dimensions: {
                width: round(width, 2),
                height: round(height, 2),
            },
            points,
        },
    };

    return row;
}

export default compileRowPolygon;
